import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { CancelTransportActions } from "store/ducks/transports";

export function* cancelTransportRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/transports/cancel/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(CancelTransportActions.success(data));
    notify("success", "Carga cancelada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CancelTransportActions.failure(errorMessage));
  }
}
